import { render, staticRenderFns } from "./TopicAnswerFill.vue?vue&type=template&id=7c1ab4fe&scoped=true&"
import script from "./TopicAnswerFill.vue?vue&type=script&lang=js&"
export * from "./TopicAnswerFill.vue?vue&type=script&lang=js&"
import style0 from "./TopicAnswerFill.vue?vue&type=style&index=0&id=7c1ab4fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1ab4fe",
  null
  
)

export default component.exports